import React, { createContext, useState } from "react";

const QueryParamsContext = createContext();

const QueryParamsContextProvider = ({ children }) => {
  const [queryParams, setQueryParams] = useState(sessionStorage);
  const [querySearch, setQuerySearch] = useState(false);
  const [tempQueryParams, setTempQueryParams] = useState({});

  return (
    <QueryParamsContext.Provider
      value={{
        queryParams,
        setQueryParams,
        querySearch,
        setQuerySearch,
        tempQueryParams,
        setTempQueryParams,
      }}
    >
      {children}
    </QueryParamsContext.Provider>
  );
};

export { QueryParamsContextProvider, QueryParamsContext };
